import React from 'react';
import Icon from '@ant-design/icons';

const CircleSvg = () => (
  <svg viewBox="0 0 640 640" width="1em" height="1em" fill="currentColor">
    <path
      d="M640 320C640 496.61 496.61 640 320 640C143.39 640 0 496.61 0 320C0 143.38 143.39 0 320 0C496.61 0 640 143.38 640 320Z"
      p-id="a9xsaXwcuz"
    />
  </svg>
);

const CircleIcon = (props) => <Icon component={CircleSvg} {...props} />;

export default CircleIcon;
